export const CMSLocationContentFromJSON = (json: ICMSLocationContent): ICMSLocationContentModel => {
	const fromJSON = (json: ICMSLocationContent) => {
		const { cms_location_id, created_at, updated_at, translations, files, ...rest } = json

		return {
			...rest,
			cmsLocationID: cms_location_id,
			translations: typeof translations === 'string' ? JSON.parse(translations) : translations,
			createdAt: created_at,
			updatedAt: updated_at,
			files: files ? files.map((file) => FileModel(file)) : [],
		}
	}

	return { ...fromJSON(json) }
}

export const CMSLocationContentToJSON = (obj: Partial<ICMSLocationContentModel>): Partial<ICMSLocationContent> => {
	const { cmsLocationID, createdAt, updatedAt, files, ...rest } = obj

	return {
		...rest,
		cms_location_id: cmsLocationID,
		created_at: createdAt,
		updated_at: updatedAt,
		files: files ? [] : [],
	}
}
